/**
 * Deep links into Schwab's own web app. Todd's URLs, used verbatim as
 * templates (see task-18 brief) — do not invent additional query params.
 */

const SCHWAB_RESEARCH_BASE = 'https://client.schwab.com/retail/research/#/stocks/';

/**
 * Symbol research page for a single underlying, e.g. `.../stocks/MA`.
 * `encodeURIComponent` is applied to the symbol so a value like `BRK/B`
 * (a real Schwab-style symbol) doesn't break the URL — plain `.` passes
 * through unescaped, which is correct: it's not a reserved character.
 */
export function schwabResearchUrl(symbol: string): string {
  return `${SCHWAB_RESEARCH_BASE}${encodeURIComponent(symbol)}`;
}

/**
 * Generic options order-ticket entry point. No symbol parameter is known
 * for this URL (see brief) — do not append one.
 */
export const SCHWAB_OPTIONS_TICKET_URL = 'https://client.schwab.com/app/trade/tom/trade?Strategy=O';
